import { render } from "./BaseSelect.vue?vue&type=template&id=34175ab1&scoped=true&ts=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"

import "./BaseSelect.vue?vue&type=style&index=0&id=34175ab1&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34175ab1"]])

export default __exports__